module.exports = __webpack_public_path__ + "img/header_icon.1297c35a.svg";